import { css } from 'styled-components'
import type { StyledFunction } from 'types/style'
import { zLayers } from '@/utils/styling/zLayers'
import type { BaseItem } from '@messenger/types'

type EditorItemProps = Partial<BaseItem> & {
  full?: boolean
  print?: boolean
}

const getItemTransform = (
  edits?: BaseItem['edits'],
  print?: boolean,
): string => {
  if (!print) return ''
  const transforms: string[] = []
  const { rotate, transform } = edits || {}
  const degrees =
    typeof rotate === 'number'
      ? rotate
      : Number.parseFloat(String(rotate ?? ''))
  const hasRotate = Number.isFinite(degrees) && degrees !== 0
  const hasTransform = typeof transform === 'string' && transform.trim() !== ''
  if (hasRotate) transforms.push(`rotate(${degrees}deg)`)
  if (hasTransform) transforms.push(transform)
  return transforms.length ? `transform: ${transforms.join(' ')};` : ''
}

export const editorItem: StyledFunction<EditorItemProps> = ({
  full,
  width,
  height,
  x,
  y,
  z,
  edits,
  print,
}) => css`
  position: absolute;
  width: ${full ? '100%' : width && `${width}px`};
  height: ${full ? '100%' : height && `${height}px`};
  z-index: ${z && `${zLayers.getZ(z)}`};
  top: ${print && y && `${y}px`};
  left: ${print && x && `${x}px`};
  ${getItemTransform(edits, print)}
`

export default editorItem
